/**
 *
 * key
 *
 */

 const key = 'dGlja2V0Q2xvc2Vk'

 export default key
 